export default __webpack_public_path__ + "static/media/y.5608e4d5.svg";